export default {"src":"/_next/static/media/cost.262aa5ef.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};